export type KeyValuePair = { key: string; value: string };

export function keyValuePairsFromJson(json?: string | null): KeyValuePair[] {
  if (!json?.trim()) return [{ key: '', value: '' }];
  try {
    const obj = JSON.parse(json) as Record<string, unknown>;
    const pairs = Object.entries(obj).map(([key, value]) => ({
      key,
      value: value == null ? '' : String(value),
    }));
    return pairs.length > 0 ? pairs : [{ key: '', value: '' }];
  } catch {
    return [{ key: '', value: '' }];
  }
}

export function keyValuePairsFromObject(obj?: Record<string, unknown> | null): KeyValuePair[] {
  if (!obj || Object.keys(obj).length === 0) return [{ key: '', value: '' }];
  return Object.entries(obj).map(([key, value]) => ({
    key,
    value: value == null ? '' : String(value),
  }));
}

export function keyValuePairsToJson(pairs: KeyValuePair[]): string {
  const obj: Record<string, string> = {};
  for (const { key, value } of pairs) {
    const k = key.trim();
    if (!k) continue;
    obj[k] = value;
  }
  return JSON.stringify(obj);
}

export function keyValuePairsToObject(pairs: KeyValuePair[]): Record<string, string> {
  const obj: Record<string, string> = {};
  for (const { key, value } of pairs) {
    const k = key.trim();
    if (!k) continue;
    obj[k] = value;
  }
  return obj;
}

/** Human-readable summary for tables and lists. */
export function formatKeyValueJsonDisplay(json?: string | null): string {
  if (!json?.trim()) return '—';
  try {
    const obj = JSON.parse(json) as Record<string, unknown>;
    const parts = Object.entries(obj)
      .filter(([k]) => k.trim())
      .map(([k, v]) => `${k}: ${v == null ? '' : String(v)}`);
    return parts.length > 0 ? parts.join(' · ') : '—';
  } catch {
    return 'Invalid criteria';
  }
}
